import React, { FC } from 'react';

import { Button } from 'antd';
import { SendOutlined } from '@ant-design/icons';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';

import { useStores } from '../../../../hooks';
import { batchActionsNamespace } from '../nameSpace';
import styles from './BatchShareButton.module.scss';

const BatchShareButton: FC = observer(() => {
    const { appStore } = useStores();
    const { t } = useTranslation();

    return (
        <Button
            data-testid="myFilesHeader_batchShareButton"
            className={styles['share-button']}
            icon={<SendOutlined className={styles.icon} />}
            onClick={() => appStore.requestShareSelectedFiles()}
        >
            {t(`${batchActionsNamespace}.share`)}
        </Button>
    );
});

export default BatchShareButton;
